import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useSupportTicket, SupportTicket } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<SupportTicket>
      useData={useSupportTicket}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

